if($('.in-klient').length){
    $('.content-inner').append('<div class="yearCount"><label for="yearSelect">Vyberte rok:</label><select id="yearSelect"></select></div>')
    function getCustomerEmail() {
        var customerData = getShoptetDataLayer('customer');
        return customerData ? customerData.email : null;
    }
    $.getJSON('/user/documents/orders.json?v='+new Date().getMinutes(), function(jsonData) {
        var email = getShoptetDataLayer('customer').email;
        if (!email || !jsonData[email]) {
            $('.content-inner').append('<p>Žádná data nejsou k dispozici pro aktuálního uživatele.</p>');
            return;
        }
        function calculateBonus(amount) {
            var nextGroupAmount = null; // Hodnota, která bude uložena, kolik ještě zbývá do další skupiny
            for (var i = 0; i < vysebonusu.length; i++) {
                var bonus = vysebonusu[i];
                if (amount >= bonus.from && amount <= bonus.to) {
                    // Pokud existuje další skupina, spočítáme, kolik zbývá do jejího dosažení
                    if (i + 1 < vysebonusu.length) {
                        nextGroupAmount = vysebonusu[i + 1].from - amount;
                        nextGroupName = vysebonusu[i + 1].name;
                    }
                    return {
                        bonus: (amount * bonus.percent) / 100,
                        name: bonus.name,
                        nextGroupAmount: nextGroupAmount, // Přidáme informaci o zbývající částce do další skupiny
                        nextGroupName: nextGroupName
                    };
                }
            }
            return { bonus: 0, name: '', nextGroupAmount: nextGroupAmount, nextGroupName:'' };
        }


        // Funkce pro plnění výběrového pole pro roky
        function populateYearSelect(data, email) {
            var yearSelect = $('#yearSelect');
            var currentYear = new Date().getFullYear();

            // Plnění roků pro aktuálně vybraný e-mail
            yearSelect.empty();
            if (data[email]) {
                $.each(data[email], function(year) {
                    yearSelect.append($('<option>', { value: year, text: year }));
                });
                yearSelect.val(currentYear); // Nastavení aktuálního roku jako vybraného
                displayData(email, currentYear);
            }

            // Změna roku
            yearSelect.change(function() {
                var selectedYear = $(this).val();
                displayData(email, selectedYear);
            });
        }

        // Funkce pro zobrazení dat
        function displayData(email, year) {
            var dataDisplay = $('#dataDisplay');
            dataDisplay.empty();

            if (jsonData[email] && jsonData[email][year]) {
                var yearData = jsonData[email][year];
                var firstHalfBonus = calculateBonus(yearData.first_half);
                var secondHalfBonus = calculateBonus(yearData.second_half);
                var obrat = '<div class="turnover">'
                    obrat += '<div class="left">'
                        obrat += '<h5>Obrat za 1. - 6. měsíc</h5>'
                        obrat += '<div class="inner">'
                            obrat += '<p class="priceTotal">'+celkovyObrat+' 1. - 6. měsíc je <span>' + Number(yearData.first_half).ShoptetFormatAsCurrency()+ '</span></p>'
                            obrat += '<p class="customerGroup">'+skupina+' <span>' + firstHalfBonus.name + '</span></p>'
                            obrat += '<p class="customerGroupNext">Do skupiny <span class="customerGroupNextPrize">'+firstHalfBonus.nextGroupName+'</span> vám zbývá nakoupit za <span class="prizeGroup">' + Number(firstHalfBonus.nextGroupAmount).ShoptetFormatAsCurrency()+ '</span></p>'
                            obrat += '<p class="cashBack">'+zpetnyBonus+' <span>' + Number(firstHalfBonus.bonus).ShoptetFormatAsCurrency()+ '</span></p>'
                        obrat += '</div>'
                    obrat += '</div>'
                    obrat += '<div class="right">'
                        obrat += '<h5>Obrat za 7. - 12. měsíc</h5>'
                        obrat += '<div class="inner">'
                            obrat += '<p class="priceTotal">'+celkovyObrat+' 7. - 12. měsíc je <span>' + Number(yearData.second_half).ShoptetFormatAsCurrency()+ '</span></p>'
                            obrat += '<p class="customerGroup">'+skupina+' <span>' + secondHalfBonus.name + '</span></p>'
                            obrat += '<p class="customerGroupNext">Do skupiny <span class="customerGroupNextPrize">'+secondHalfBonus.nextGroupName+'</span> vám zbývá nakoupit za <span class="prizeGroup">' + Number(secondHalfBonus.nextGroupAmount).ShoptetFormatAsCurrency()+ '</span></p>'
                            obrat += '<p class="cashBack">'+zpetnyBonus+' <span>' + Number(secondHalfBonus.bonus).ShoptetFormatAsCurrency() + '</span></p>'
                        obrat += '</div>'
                    obrat += '</div>'
                    obrat += '<div class="hlaska"><p>'+hlaskaPodCarou+'</p></div>'
                obrat += '</div>'
                if(!$('.turnover').length){
                    $('.content-inner').append(obrat);
                }
                else{
                    $('.hlaska').remove()
                    $('.turnover').remove();
                    $('.content-inner').append(obrat);
                }
                
            } else {
                $('.content-inner').append('<p>Žádná data nejsou k dispozici.</p>');
            }
        }

        // Inicializace
        populateYearSelect(jsonData, email);
    }).fail(function() {
        $('.content-inner').append('<p>Chyba při načítání dat.</p>');
    });
    
}